import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DreamLand } from '../../models/dream/DreamLand';
import { getDateRelative } from '../shared/getDateRelative';
import { IslandName } from '../shared/IslandName';
import { DownloadCount } from './DownloadCount';

interface MyIslandDreamTextProps {
  dreamLand: DreamLand;
}

export const MyIslandDreamText: React.FC<MyIslandDreamTextProps> = React.memo(({ dreamLand }) => {
  const { t, i18n } = useTranslation(['dream', 'translation']);

  const updatedAtRelative = getDateRelative(new Date(dreamLand.dreamLand.updatedAt * 1000));
  const updatedAtString = t(
    `translation:${updatedAtRelative.transKey}`,
    updatedAtRelative.option as any
  );

  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        overflow: hidden;
        .landname {
          font-size: 20px;
          color: #4d3906;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          max-width: 100%;
        }
        .visitors {
          margin: 4px 0 0;
          em {
            color: #a364d6;
            font-style: normal;
          }
        }
        .updated-at {
          display: flex;
          align-items: center;
          margin: 8px 0 0;
        }
      `}
    >
      <div className="landname">
        <IslandName
          landName={dreamLand.uploadUser.land.name}
          landDisplayId={dreamLand.uploadUser.land.displayId}
          language={i18n.language}
        />
      </div>
      {dreamLand.downloadCount > 0 && (
        <div className="visitors">
          <DownloadCount count={dreamLand.downloadCount} />
        </div>
      )}
      <div className="updated-at">
        <span>{t('my_islands_dream_update_00')}</span>
        <span>{updatedAtString}</span>
      </div>
    </div>
  );
});
